<template>
  <div class="intermediate_wrap">
    <div class="taxation_title">
      <h2>智能财税中级1.0</h2>
    </div>
    <ul v-if="productFlag==3" class="taxation_item">
      <li>
        <img src="../img/ctx-logo.png" alt="" class="app_logo">
        <img src="../img/ctx-bg.png" alt="" class="app_bg">
        <span class="text">（中级1.0）</span>
        <el-button @click="entrySys('ctx')">进入系统</el-button>
      </li>
      <li>
        <img src="../img/ptx-logo.png" alt="" class="app_logo">
        <img src="../img/ptx-bg.png" alt="" class="app_bg">
        <span class="text">（中级1.0）</span>
        <el-button @click="entrySys('ptx')">进入系统</el-button>
      </li>
      <li>
        <img src="../img/jss-logo.png" alt="" class="app_logo">
        <img src="../img/jss-bg.png" alt="" class="app_bg">
        <span class="text">（中级1.0）</span>
        <el-button @click="entrySys('jss')">进入系统</el-button>
      </li>
      <li>
        <img src="../img/gxl-logo.png" alt="" class="app_logo">
        <img src="../img/ctx-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('gxl')">进入系统</el-button>
      </li>
    </ul>
		<el-dialog
		  :visible.sync="centerDialogVisible"
		  width="400px"
		  center>
		  <div class="cont">
				<p>请选择您要进入的案例公司：</p>
				<ul>
					<li :class="{active : index===curId}" v-for="(item,index) in companyList" :key="index" @click="tabClick(item,index)">{{item.name}}</li>
				</ul>
			</div>
		</el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import crypto from 'crypto'
import * as userApi from '../../../../api/userApi'
export default {
  data() {
    return {
      sysUserPermissionList: JSON.parse(localStorage.getItem('sysUserPermissionList'))  || [], // 权限对象
      userType: sessionStorage.getItem('userType'), //用户身份
      isStudent: false,
      productFlag: sessionStorage.getItem('productFlag'),
			centerDialogVisible: false,
			companyList: [
				{name:'北京神龙贸易有限公司',code:'BJ009312',tcode: '001'},
				{name:'北京星晨办公用品有限公司',code:'BJ009319',tcode: '002'},
				{name:'杭州康健医疗器械有限公司',code:'BJ009321',tcode: '003'},
				{name:'北京乐嘉食品有限责任公司',code:'BJ013145',tcode: '004'}
			],
			curId: null,
			sys: ''
    };
  },
  created() {
    if(this.userType==2 || this.userType==3){
      this.isStudent = true
    }else{
      this.isStudent = false
    }
  },
  methods: {
    setSha1(url){//sha1加密
      const hmac = crypto.createHmac('sha1', '123456');
      hmac.update(url);
      return hmac.digest('hex')
    },
    entrySys(sys){
      if(localStorage.getItem('Authorization')){
				let param = {
					productCode:'ctx',
					productLevel:2
				}
				userApi.intoSysJudge(param).then(res=>{
					if(res.code == 0){
						this.sys = sys
						if((res.data.length < this.companyList.length) && (sys=='ctx'||sys=='ptx'||sys=='jss'||sys=='gxl')){
							this.centerDialogVisible = true;
							this.curId = null;
						}else{
							userApi.isExpired(localStorage.getItem('Authorization')).then(rs=>{
							  if(rs.code==0 && rs.data==0){
							    if(sys=='ctx'||sys=='ptx'||sys=='jss'||sys=='gxl'){
							      let userType = this.userType
							      // let deptIdArr = ['129','134','13','516','653','648']
							      // if((userType==2||userType==3) && !deptIdArr.includes(sessionStorage.getItem('deptId'))){
							      //   this.$messageWarning('暂未开放')
							      //   this.loading = false
							      //   return
							      // }
							      // if((sessionStorage.getItem('auditStatus')!=2) && userType==1 ){
							      //   this.$messageWarning('没有访问权限，请联系学校管理员提交账号审核。')
							      //   this.loading = false
							      //   return
							      // }
							      var tmpWin = window.open()
							      tmpWin.document.open();
							      tmpWin.document.write("跳转中，请稍后。。。");
							      tmpWin.document.close();
							      let phone = sessionStorage.getItem('mobile')
							      let name = sessionStorage.getItem('loginName')
							      let schoolId = sessionStorage.getItem('deptId')
							      let schoolName = sessionStorage.getItem('deptName')
							      let time = new Date().getTime() +""
							      let userId = sessionStorage.getItem('userId')
							      let classId = ''
							      let courseId = ''
							      classId = sessionStorage.getItem('userId')+'8888'
							      courseId = sessionStorage.getItem('deptId')+'8888'

							      let url = 'classId='+classId+'&className=智能财税中级师资研修班&courseId='+courseId+'&mobile='+phone+'&nickName='+name+'&platform='+sys+'&questionId=999998888&schoolId='+schoolId+'&schoolName='+schoolName+'&time='+time+'&userId='+userId+'&userType='+userType
							      let sha1sign = this.setSha1(url)
							      let templates = ''
							      if(process.env.hostStr=='zledusx'){
							        templates = "BJ009312,BJ009319,BJ009321,BJ013145"
							      }else{
							        templates = "001,002,003,004,005"
							      }
							      let stxObj = {
							        courseId: courseId,
							        classId: classId,
							        className: '智能财税中级师资研修班',
							        mobile: phone,
							        nickName: name,
							        platform: sys,
							        questionId: '999998888',
							        schoolId: schoolId,
							        schoolName: schoolName,
							        templates: templates,
							        time: time,
							        userId: userId,
							        userType: this.userType,
							        sign: sha1sign
							      }
							      axios.post(process.env.STX1_API,qs.stringify(stxObj)).then(res=>{
							        if(res.data.result){
							          tmpWin.location = res.data.value
							          this.loading = false
							        }else{
							          this.$messageError(res.data.error.message)
							          tmpWin.document.open();
							          tmpWin.document.write(res.data.error.message);
							          tmpWin.document.close();
							          this.loading = false
							        }
							      }).catch(err=>{
							        tmpWin.document.open();
							        if(err.code == '401'){
							          tmpWin.document.write("登录已过期，请重新登录");
							          tmpWin.location.href = process.env.BASE_API
							        }else{
							          tmpWin.document.write("接口访问异常"+err.code);
							        }
							        tmpWin.document.close();
							        this.loading = false
							      })
							    }else{
							      this.loading = false
							      this.$messageWarning('暂无权限，请联系管理员！')
							    }
							  }else{
							    this.$router.push({path:'/home'})
							    this.$messageError('登录已过期，请重新登录')
							    localStorage.removeItem('Authorization')
							    localStorage.removeItem('isbinding')
							  }
							}).catch(err=>{
							  console.log(err)
							})
						}
					}
				})
      }else{
        this.loading = false
        this.$router.push({path:'/home'})
      }
    },
		tabClick(item,i){
			this.curId = i;
			let code = ''
			if(process.env.hostStr=='zledusx'){
				code = item.code
			}else{
				code = item.tcode
			}
			let param = {
				"productCode":"ctx",
		    "productLevel":2,
		    "templateCode": code
			}
			userApi.selectSysJudge(param).then(res=>{
				console.log(res);
				if(res.code == 0){
					userApi.isExpired(localStorage.getItem('Authorization')).then(rs=>{
					  if(rs.code==0 && rs.data==0){
					    if(this.sys=='ctx'||this.sys=='ptx'||this.sys=='jss'||this.sys=='gxl'){
					      let userType = this.userType
					      // let deptIdArr = ['129','134','13','516','653','648']
					      // if((userType==2||userType==3) && !deptIdArr.includes(sessionStorage.getItem('deptId'))){
					      //   this.$messageWarning('暂未开放')
					      //   this.loading = false
					      //   return
					      // }
					      // if((sessionStorage.getItem('auditStatus')!=2) && userType==1 ){
					      //   this.$messageWarning('没有访问权限，请联系学校管理员提交账号审核。')
					      //   this.loading = false
					      //   return
					      // }
					      var tmpWin = window.open()
					      tmpWin.document.open();
					      tmpWin.document.write("跳转中，请稍后。。。");
					      tmpWin.document.close();
					      let phone = sessionStorage.getItem('mobile')
					      let name = sessionStorage.getItem('loginName')
					      let schoolId = sessionStorage.getItem('deptId')
					      let schoolName = sessionStorage.getItem('deptName')
					      let time = new Date().getTime() +""
					      let userId = sessionStorage.getItem('userId')
					      let classId = ''
					      let courseId = ''
					      classId = sessionStorage.getItem('userId')+'8888'
					      courseId = sessionStorage.getItem('deptId')+'8888'

					      let url = 'classId='+classId+'&className=智能财税中级师资研修班&courseId='+courseId+'&mobile='+phone+'&nickName='+name+'&platform='+this.sys+'&questionId=999998888&schoolId='+schoolId+'&schoolName='+schoolName+'&time='+time+'&userId='+userId+'&userType='+userType
					      let sha1sign = this.setSha1(url)
					      let templates = code
					      // if(process.env.hostStr=='zledusx'){
					      //   templates = "BJ009312,BJ009319,BJ009321,BJ013145"
					      // }else{
					      //   templates = "001,002,003,004,005"
					      // }
					      let stxObj = {
					        courseId: courseId,
					        classId: classId,
					        className: '智能财税中级师资研修班',
					        mobile: phone,
					        nickName: name,
					        platform: this.sys,
					        questionId: '999998888',
					        schoolId: schoolId,
					        schoolName: schoolName,
					        templates: templates,
					        time: time,
					        userId: userId,
					        userType: this.userType,
					        sign: sha1sign
					      }
					      axios.post(process.env.STX1_API,qs.stringify(stxObj)).then(res=>{
					        if(res.data.result){
					          tmpWin.location = res.data.value
					          this.loading = false
					        }else{
					          this.$messageError(res.data.error.message)
					          tmpWin.document.open();
					          tmpWin.document.write(res.data.error.message);
					          tmpWin.document.close();
					          this.loading = false
					        }
					      }).catch(err=>{
					        tmpWin.document.open();
					        if(err.code == '401'){
					          tmpWin.document.write("登录已过期，请重新登录");
					          tmpWin.location.href = process.env.BASE_API
					        }else{
					          tmpWin.document.write("接口访问异常"+err.code);
					        }
					        tmpWin.document.close();
					        this.loading = false
					      })
					    }else{
					      this.loading = false
					      this.$messageWarning('暂无权限，请联系管理员！')
					    }
					  }else{
					    this.$router.push({path:'/home'})
					    this.$messageError('登录已过期，请重新登录')
					    localStorage.removeItem('Authorization')
					    localStorage.removeItem('isbinding')
					  }
					}).catch(err=>{
					  console.log(err)
					})
				}
			})
		}
  }
}
</script>
<style lang="scss" scoped>
.intermediate_wrap {
  .taxation_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #5397f7;
    h2 {
      border-left: 2px solid #5397f7;
      color: #5397f7;
      font-size: 14px;
      padding-left: 4px;
      line-height: 10px;
    }
  }
  .taxation_item {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 24px;
    li{
      width:278px;
      height:180px;
      background:rgba(255,255,255,1);
      box-shadow:0px 2px 8px rgba(0,0,0,0.16);
      border-radius:4px;
      position: relative;
      margin-top: 24px;
      margin-right: 40px;
      .app_logo{
        position: absolute;
        left: 40px;
        top: 48px;
        z-index: 2;
        height: 22px;
      }
      .app_bg{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        width:278px;
        height:180px;
      }
      button{
        position: absolute;
        left: 40px;
        bottom: 24px;
        z-index: 2;
        width:96px;
        height:34px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(83,151,247,1);
        border-radius:4px;
        padding: 0;
        color: #5397F7;
        &:hover{
          background: #5397F7;
          color: #fff;
        }
      }
      .text{
        position: absolute;
        left: 32px;
        top: 45%;
        z-index: 2;
        font-size: 16px;
        color: #004e97;
        font-weight: 600;
      }
    }
  }
	/deep/ .el-dialog__header {
		height: 48px;
		background: #edf4ff;
		padding: 20px 15px 0;
		box-sizing: border-box;
		border-radius: 8px 8px 0 0;
	}
	.cont {
		p {
			font-size: 16px;
			margin-bottom: 10px;
		}
		ul {
			width: 180px;
			margin: 0 auto;
			li {
				font-size: 14px;
				cursor: pointer;
				line-height: 24px;
				text-align: left;
			}
			li.active {
				color: #5397F7;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/views/appCenter/components/intermediateOne.vue